import React, { Component } from 'react';
import JsBarcode from 'jsbarcode';

/**
 * Barcode Generator Class
 * Dependencies - React, jsbarcode (npm install jsbarcode)
 * How to use: Import Barcode and pass the configuration as props.
 * 
 * OPTIONS  => code, format, width, height, displayValue, background, print 
 * 
 * Format types:
 * CODE128* - * can be nothing, A, B, or C
 * CODE39
 * ITF14
 * EAN* - * can be 13, 8, 5, 2
 * MSI* - * can be nothing, 10, 11, 1010 ,1110
 * PHARMACODE
 * CODABAR
 * 
 * PS: TO PRINT THE BARCODE SEND print={true}
 * * Example:
 * <Barcode code={"3132A312F"} format={"CODE128A"} displayValue={true} width={3} height={60}  background={"#fff"}, print={true} />
 */
export default class Barcode extends Component
{   
    /**
     * get the barcode SVG element before the component mount to bind the barcode image.
     */
    componentDidMount()
    {
        this.setBarcode(this.props);
    }
    /**
     * Set new information to the barcode object.
     * @param {Object} ownProps - New barcode information
     */
    componentWillReceiveProps(ownProps)
    {
        this.setBarcode(ownProps);
    }

    setBarcode(props)
    {
        let bc = document.getElementById('barcode');
        JsBarcode(bc, props.code || "enterValidCode",
                    {
                        format: props.format || "CODE128",
                        width: props.width || 3,
                        height: props.height || 50,
                        displayValue: (props.displayValue || props.displayValue !== false) ? true : false ,
                        background: props.background || "#fff",
                        fontSize: 10
                    });
        if(props.print)
        {
            this.print()
        }
    }
    /**
     * Method to print barcode
     */
    print()
    {
        window.print();
    }
    
    render()
    {
        return(
            <div className="barcodeCenter">
                <svg id="barcode" className="svg" />
            </div>
        );
    }
}